export default __webpack_public_path__ + "static/media/Roboto-LightItalic.a9cccd17.ttf";